<ion-content class="ion-padding modal">
  <ion-header>
    <ion-icon
      name="close"
      class="fs-5 font700"
      (click)="closeModal()"
    ></ion-icon>
  </ion-header>
  <div class="d-flex ion-justify-content-center">
    <ion-img
      src="/assets/homieGif/paymentFailed.gif"
      class="failed-gif"
    ></ion-img>
  </div>
  <div class="d-flex flex-col ion-align-items-center">
    <ion-label class="font700 boldText"> {{ type == 'error' ? title : 'Payment failed' | translate }} </ion-label>
    <ion-text class="font700 boldText padt10" *ngIf=" type !== 'error' && hotelDetails?.hotelName">
       {{hotelDetails?.hotelName}}
    </ion-text>
  </div>

  <div class="fs-4 font400 ion-text-center ion-padding-top ion-padding-bottom">
    <ion-label> {{ type == 'error' ? message  : 'Try again or pay with another card.' | translate }}</ion-label>
  </div>

  <div class="button-box">
    <ion-button  class="primary-btn ion-margin-top" expand="block" (click)="handlePostiveResponse()" *ngIf="showYesBtn"
      > {{ yesButtonText }} </ion-button
    >
    <ion-button *ngIf="type == 'error' && showNoBtn" class="outline-btn ion-margin-top" expand="block" (click)="handleNegativeResponse()"> {{ noButtonText }} </ion-button>
  </div>
  <div *ngIf="bookingReferenceId" class="fs-2 font400 ion-text-center ion-padding-top ion-padding-bottom desc-text-color">
    <ion-label class="help" (click)="help()">Need help with this transaction?</ion-label>
  </div>
</ion-content>
